import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";

export default function Environment360() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/environment/overview").then(({ data }) => setData(data)); }, []);
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Environment360" title="Environmental Monitoring & Compliance" description="Fenceline air quality, effluent, groundwater, noise, dust — real-time monitoring against permit limits with regulatory-ready reports." />
            <KpiGrid kpis={data?.kpis || []} accent="green" cols={4} />
            <Panel title="Recent Environmental Readings" accent="green">
                <DataTable
                    columns={[
                        { key: "date", label: "Date", render: (r) => r.date.slice(0, 10) },
                        { key: "station", label: "Station" },
                        { key: "name", label: "Location" },
                        { key: "parameter", label: "Param" },
                        { key: "value", label: "Value", render: (r) => `${r.value} ${r.unit}` },
                        { key: "limit", label: "Limit", render: (r) => `${r.limit} ${r.unit}` },
                        { key: "status", label: "Status", render: (r) => <StatusChip status={statusToChip(r.status)}>{r.status}</StatusChip> },
                    ]}
                    rows={(data?.readings || []).slice(0, 30)}
                    testid="env-readings"
                />
            </Panel>
        </div>
    );
}
